module.exports = __webpack_public_path__ + "static/media/tractor.0966eef2.png";